// extracted by mini-css-extract-plugin
module.exports = {"LithLogo":"LithLogo_LithLogo__3DCtQ","svg":"LithLogo_svg__4nITi"};